import script from "./admin_apiKey.vue?vue&type=script&setup=true&lang=js"
export * from "./admin_apiKey.vue?vue&type=script&setup=true&lang=js"

import "./admin_apiKey.vue?vue&type=style&index=0&id=43249d2c&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43249d2c"]])

export default __exports__